export default __webpack_public_path__ + "static/media/cern-extrabold-italic.9b159e0d.ttf";